<template>
    <div
        class="o-p-player"
        :style="componentStyles"
        :key="renderKey"
    >
        <div
            class="o-p-player__wrapper"
            v-show="!isShowPlaceholder"
        >
            <img 
                v-if="componentParams.imageSrc" 
                :src="componentParams.imageSrc" 
                alt="mobilia player"
            >
            <iframe 
                v-else-if="iframeSrc && iframeSrc !== '/'" 
                class="o-p-player__frame" 
                :src="iframeSrc"
            ></iframe>
            <img 
                v-else 
                src="../../../assets/images/posters/mobilia.png" 
                alt="mobilia player"
            >
        </div>
        <img 
            v-show="isShowPlaceholder && placeholderSrc" 
            :src="placeholderSrc" 
            alt="mobilia player"
            class="o-p-player__placeholder"
        >
        <OLoadingOverlay
            v-show="isShowPlaceholder && !placeholderSrc" 
            class="o-p-player__placeholder"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OLoadingOverlay from '../o-loading-overlay/o-loading-overlay.vue'
import {reportWarning, reportError} from "@/utils/helpers/health-monitoring";

export default {
    name: 'OPPlayer',
    components: {
        OLoadingOverlay
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            renderKey: 0,
            cooldownTimer: null,
            exceptionTimer: null,
            canSendException: true,
            canSendPlaybackException: false,
            isShowPlaceholder: true
        }
    },
    computed: {
        ...mapGetters([
            'getTerminalId',
            'getMapConfigProp'
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.OPPlayer.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OPPlayer.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OPPlayer.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.OPPlayer.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        iframeSrc() {
            if(this.$route.query.playerUrl) {
                return this.$route.query.playerUrl
            }
            return this.componentParams.src
        },
        cooldownHealthTime() {
            return this.componentParams.cooldown_health_time || 300000
        },
        placeholderSrc() {
            return this.componentParams.placeholder_src || ''
        }
    },
    methods: {
        checkIframeHealth(event){
            if(event && event.data === 'player_loaded') {
                this.isShowPlaceholder = false
            }
            
            if(event && event.data === 'loop_end') {
                if(this.cooldownTimer) clearTimeout(this.cooldownTimer)
                this.isShowPlaceholder = false

                this.cooldownTimer = setTimeout(() => {
                    ++this.renderKey
                    this.exceptionHandler();
                    this.canSendPlaybackException = true
                    this.isShowPlaceholder = true
                }, this.cooldownHealthTime)

                this.playbackExceptionHandler();
            }
        },
        exceptionHandler() {
            if(this.canSendException) {
                const msg = `Signage-player: Not Playing. Iframe src: ${this.iframeSrc}. In poster with id ${this.getTerminalId}`;
                reportError(msg);
                this.canSendException = false
                this.exceptionTimer = setTimeout(() => {
                    this.canSendException = true
                }, 3600000)
            }
        },
        playbackExceptionHandler() {
            if(this.canSendPlaybackException) {
                const msg = `Signage-player: Playback recovered. Iframe src: ${this.iframeSrc}. In poster with id ${this.getTerminalId}`;
                reportWarning(msg);
                this.canSendPlaybackException = false
            }
        }

    },
    mounted() {
        window.addEventListener("message", this.checkIframeHealth, false);
    },
    beforeDestroy() {
        if(this.cooldownTimer) clearTimeout(this.cooldownTimer)
        if(this.exceptionTimer) clearTimeout(this.exceptionTimer)
        
        window.removeEventListener("message", this.checkIframeHealth, false);
    }
}
</script>

<style lang="scss">
@import "o-p-player";
</style>
